import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { MainColors } from '../../../constants/Colors';
import FontSizes from '../../../constants/FontSizes';
import { MaterialCommunityIcons } from '@expo/vector-icons';

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const pageNumbers = [];

    const [isPrevButtonDisabled, setIsPrevButtonDisabled] = useState();
    const [isNextButtonDisabled, setIsNextButtonDisabled] = useState();

    for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
        pageNumbers.push(i);
    }
    
    useEffect(() => {
        const firstPage = pageNumbers[0];
        const lastPage = pageNumbers.length;

        if (pageNumbers.length > 1) {
            if (currentPage === firstPage) {
                setIsPrevButtonDisabled(true);
                setIsNextButtonDisabled(false);
            } else if (currentPage === lastPage) {
                setIsNextButtonDisabled(true);
                setIsPrevButtonDisabled(false);
            } else {
                setIsPrevButtonDisabled(false);
                setIsNextButtonDisabled(false);
            }
        } else {
            setIsPrevButtonDisabled(true);
            setIsNextButtonDisabled(true);
        }

    }, [paginate]);

    const onPrevButtonPressedHandler = () => {
        if (currentPage > pageNumbers[0]) {
            paginate(currentPage - 1);
        }
    }

    const onNextButtonPressedHandler = () => {
        if (currentPage < pageNumbers.length) {
            paginate(currentPage + 1);
        }
    }

    return (
        <View style={styles.container}>
            <TouchableOpacity
                style={styles.arrowButtonContainer}
                disabled={isPrevButtonDisabled}
                onPress={onPrevButtonPressedHandler}
            >
                <MaterialCommunityIcons
                    name="chevron-left"
                    size={18}
                    color={isPrevButtonDisabled ? MainColors.lightGray : MainColors.mediumGray}
                />
                <Text style={isPrevButtonDisabled ? styles.disabledButtonText : styles.buttonText}>Prev</Text>
            </TouchableOpacity>
            <View style={styles.numberButtonsContainer}>
                {/* only show 2 pages before and 2 pages after the current page */}
                {pageNumbers.filter(pn => pn < currentPage + 2 || pn > currentPage - 2).map(number => (
                    <TouchableOpacity
                        style={number === currentPage ? styles.currentNumberButton : styles.numberButton}
                        key={number} onPress={() => paginate(number)}>
                        <Text style={number === currentPage ? styles.currentNumber : styles.number}>
                            {number}
                        </Text>
                    </TouchableOpacity>
                ))}
            </View>
            <TouchableOpacity
                style={styles.arrowButtonContainer}
                disabled={isNextButtonDisabled}
                onPress={onNextButtonPressedHandler}
            >
                <Text style={isNextButtonDisabled ? styles.disabledButtonText : styles.buttonText}>Next</Text>
                <MaterialCommunityIcons
                    name="chevron-right"
                    size={18}
                    color={isNextButtonDisabled ? MainColors.lightGray : MainColors.mediumGray}
                />
            </TouchableOpacity>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        borderBottomColor: MainColors.faintGray,
        borderBottomWidth: 1,
        paddingBottom: 10,
    },
    arrowButtonContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    buttonText: {
        color: MainColors.mediumGray,
        fontSize: FontSizes.medium
    },
    disabledButtonText: {
        color: MainColors.lightGray,
        fontSize: FontSizes.medium
    },
    numberButtonsContainer: {
        marginHorizontal: 5,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    currentNumberButton: {
        marginHorizontal: 5,
        borderRadius: 4,
        borderWidth: 1.5,
        borderColor: MainColors.primary,
        paddingVertical: 2,
        paddingHorizontal: 8,
        backgroundColor: MainColors.primary
    },
    numberButton: {
        marginHorizontal: 5,
        borderRadius: 4,
        borderWidth: 1.5,
        borderColor: MainColors.primary,
        paddingVertical: 2,
        paddingHorizontal: 8,
    },
    currentNumber: {
        color: 'white',
        fontSize: FontSizes.medium,
        fontWeight: '500'
    },
    number: {
        color: MainColors.primary,
        fontSize: FontSizes.medium,
        fontWeight: '500'
    },
});



export default Pagination;